export default "__VITE_ASSET__6589729b__"